<template>
  <div>
      <router-view></router-view>
      <tabbar v-model="active"  safe-area-inset-bottom @change="switchTab" active-color="#ff976a" :zIndex="1001">
          <tabbar-item v-for="(item,index) in tabBarList" :key="index" :icon="item.icon" :to="{name:item.name}" :name="index" replace>{{item.text}}</tabbar-item>
      </tabbar>
  </div>
</template>

<script>
    import {Tabbar, TabbarItem} from 'vant';
    export default {
        name: 'Main',
        components: {
            Tabbar,
            TabbarItem
        },
        methods:{
            switchTab:function(e){
                this.tabBarList.forEach((item,index)=>{
                  if(item.name==e){
                      this.active    =   index;
                  }
                })
            }
        },
        data() {
            return {
                active:0,
                tabBarList: [
                    {
                        name: "index",
                        icon: 'home-o',
                        text: '首页',
                    }, 
                    {
                        name: "venue",
                        icon: 'cluster-o',
                        text: '场馆',
                    },
                    {
                        name: "my",
                        icon: 'contact',
                        text: '我的',
                    }
                ]
            }
        },
        watch: {
            '$route.name':function(e){
              this.switchTab(e);
            }
        },
        mounted(options) {
            this.$nextTick(() => {
                this.switchTab(this.$route.name);
            })

        }
    }
</script>
